import { IPrivateIndividual } from '../../../../../../models/partnerportalen/private-individual.model';

export class PrivateIndividualAdministratorApiModel {
  id!: number;
  personalIdentityNumber!: string;
  email!: string;
  reason!: string;
  isVerified!: boolean;

  static mapToBusinessModel(apiModel: PrivateIndividualAdministratorApiModel): IPrivateIndividual {
    return {
      id: apiModel.id,
      personalIdentityNumber: apiModel.personalIdentityNumber,
      email: apiModel.email,
      reason: apiModel.reason,
      isConsentGiven: true,
      isVerified: apiModel.isVerified,
    };
  }
}
